import { ChildrenProps } from 'core/dom/types';

export function EmptyLayout({ children }: ChildrenProps) {
  return <>{children}</>;
}
